import getDateParts from './getDateParts';
/**
 * Split a date into parts according to the provided format.
 *
 * @param {String} date - the date to split
 * @returns {String}
 */
export default function getValidDate(date) {
  let dateFormat = {};
  if (date.indexOf('/') > -1) {
    dateFormat = getDateParts(date);
  } else if (date.indexOf('-') > -1) {
    dateFormat = getDateParts(date, 'yyyy-MM-dd');
  }
  let strDate = '';
  if (dateFormat.year && dateFormat.month && dateFormat.day) {
    const strYear = dateFormat.year;
    const strMonth = (dateFormat.month >= 0 && dateFormat.month <= 9) ? `0${dateFormat.month}` : dateFormat.month;
    const strDay = (dateFormat.day >= 0 && dateFormat.day <= 9) ? `0${dateFormat.day}` : dateFormat.day;
    strDate = `${strMonth}/${strDay}/${strYear}`;
  }
  return strDate;
}
